// import Vue from 'vue'
import axios from "../helpers/axios";
import router from "../router";

// Estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default {
  // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
  namespaced: true,

  state: {
    // accessToken: null,
    logingIn: false,
    loginError: false,
    loginMessage: "hola",
    loginPerfil: [],
    subModuloEvento: {}    
  },

  mutations: {
    // new login
    loginStart(state) {
      state.logingIn = true;
    },

    loginStop(state, errorMessage) {
      state.logingIn = false;
      state.loginError = true;
      state.loginMessage = errorMessage;
    },

    loginLimipiar(state) {
      state.loginError = false;
      state.loginMessage = null;
    },

    logout(state) {
      state.logingIn = false;
      sessionStorage.clear();
      // limpiar la Session Store
      //  state.accessToken = null;
    },
    // Actualizado el perfil
    usuarioPerfil(state, perfil) {
      state.loginPerfil = perfil;
    },


    loadSucursal(state, sucursal) {
      console.log(`login.js, loadSucursal ${JSON.stringify(sucursal)} `)
      //console.log(`login.js, loadSucursal ${JSON.stringify(sucursal)} `)
      sessionStorage.setItem('id_sucursal', sucursal.id)
      sessionStorage.setItem('nombre_sucursal', sucursal.nombre_sucursal)   
      
      // EN EL STATE DE VUE NO ES NECESARIO 
      // state.id_sucursal = sucursal.id
      // state.nombre_sucursal = sucursal.nombre_sucursal

    },

  
  },

  actions: {
    limpiarLogin({ commit }) {
      commit("loginLimipiar");
    },
    // limpiar Error Login

    // new login
    verificarSession({ commit}, loginData) {
      // console.log(`*** login.js  verificarSession() datos de entrada: ${JSON.stringify(loginData)} ****`);
      /// alert(`*** login.js  verificarSession() datos de entrada: ${JSON.stringify(loginData)} ****`)
      
      let urlLogin  = "/sistema/main/login/" 
      let routerHome = "/homeSystem"
      
      console.log(` **login.js**  verificarSession(): ${JSON.stringify(loginData)} `)
    
      if(loginData.sistema == "manager"){
        urlLogin  = "/sistema/main/login/"
        routerHome= "/homeManager"
      }

      
      axios
        .post(urlLogin, { ...loginData })
        .then((response) => {
          //commit('loginStop', null);

          // console.log(`urlLogin (${JSON.stringify(response)})`)
          sessionStorage.clear();
          
          let sucursal = response.data.sucursal
          let usuario = response.data.usuario
          let empresa = response.data.empresa

        
          
          if (usuario) {
            // inicio la sesionen el STORE
            commit("loginStart");
            // creo la variables en el SessionStore
            // console.log(` ***  01 Repuesta del Servidor ***`);
            // console.log(usuario);    
            // datos Session
            sessionStorage.setItem("token", loginData.token);
            sessionStorage.setItem("autentificado", true);
            sessionStorage.setItem("id", usuario.id);
            sessionStorage.setItem("usu_usuario", usuario.usu_usuario);
            sessionStorage.setItem("token_usuario", usuario.token_usuario);
            sessionStorage.setItem("ip_usuario", usuario.token_usuario);
            sessionStorage.setItem("expiracion", "2019-01-01");
                        // sistema 
            sessionStorage.setItem('nombre_sistema', 'KWSOLUCIONES')
            sessionStorage.setItem('archivo_ruta_sistema', '/archivo/sistema/getLogo/archivo/')
            sessionStorage.setItem('archivo_nombre_sistema', 'logo.jpg')

            // EMPRESA DE SESSION
            sessionStorage.setItem('id_empresa', empresa.id)
            sessionStorage.setItem('nombre_empresa', empresa.nombre_empresa)
            sessionStorage.setItem('web_empresa', empresa.web_empresa)
            sessionStorage.setItem('codigo_fiscal_empresa', empresa.codigo_fiscal)
            sessionStorage.setItem('telf_empresa', empresa.telf_empresa)
            sessionStorage.setItem('direc_empresa', empresa.direc_empresa)
            sessionStorage.setItem('correo_empresa', empresa.correo_empresa)
            sessionStorage.setItem('logo_ruta_empresa', empresa.logo_ruta)
            sessionStorage.setItem('logo_nombre_empresa', empresa.logo_nombre)

            // SUCURSAL
            sessionStorage.setItem('id_sucursal', sucursal.id)
            sessionStorage.setItem('nombre_sucursal', sucursal.nombre_sucursal)
            sessionStorage.setItem('total_sucursal', sucursal.total_sucursal)
            sessionStorage.setItem('modal_sucursal', sucursal.modal_sucursal)
            
            // usuario Perfil
            sessionStorage.setItem("id_perfil", usuario.id_perfil)
            sessionStorage.setItem("descripcion_perfil",usuario.descripcion_perfil)
            sessionStorage.setItem("webmaster", usuario.webmaster)
 
            
            // Datos Básicos
            sessionStorage.setItem('id_persona', usuario.id_persona)
            sessionStorage.setItem('nombre_persona', usuario.nombre_persona)
            sessionStorage.setItem('ape1_persona', usuario.ape1_persona)
            sessionStorage.setItem('ape2_persona', usuario.ape2_persona)
            sessionStorage.setItem('numdoc_persona', usuario.numdoc_persona)
            sessionStorage.setItem('ruta_avatar_persona', usuario.ruta_avatar_persona)
            sessionStorage.setItem('avatar_persona', usuario.avatar_persona)
            sessionStorage.setItem('correo_persona', usuario.correo_persona)
            sessionStorage.setItem('fecnac_persona', usuario.fecnac_persona)
            sessionStorage.setItem('telf_persona', usuario.telf_persona)
            sessionStorage.setItem('sexo_persona', usuario.sexo_persona)
            sessionStorage.setItem('datos', response.data)
            
            


            // Datos Configuracion de perfil
            // console.log( `***  01 Existe Usuario  ${JSON.stringifyperfilConfig} ******************`)
            //sessionStorage.setItem('perfil_config', perfilConfig[0])

            // Ingreso en el Sistema en la ruta HOME
            router.push(routerHome);

          } else {
            commit("loginStop", "No Existe el Usuario o Contraseña");
            console.log(` ***  02 Repuesta del Servidor ***`);
            // loginStop: (state, errorMessage)

            //sessionStorage.clear()
            //let resp = {"error" : true, mensaje :"error en sesion" }
            //return resp //alert('error en sesion ')
          }
        })
        .catch((e) => {
          //commit('loginStop', error.response.data.error);
          console.log(` error  xxxx ${e}`);
          commit("loginStop", e);
        });
    },

    async logout({ commit }) {
      //sessionStorage.removeItem('accessToken');
      let data = {
        token: sessionStorage.getItem('token')
      }
      await axios.post("/sistema/main/logout", data);
      commit("logout");
      router.push("/login");
    },

    doLoginOriginal({ commit }, loginData) {
      commit("loginStart");

      axios
        .post("/sistema/usuario/login/", {
          ...loginData,
        })

        .then((response) => {
          commit("loginStop", null);

          if (response.data) {
            sessionStorage.setItem(
              "accessToken",
              JSON.stringify(response.data)
            );
            commit("updateAccessToken", response.data);
            router.push("/Home");
          } else {
            alert("error en sesion ");
          }
        })

        .catch((error) => {
          commit("loginStop", error.response.data.error);
        });
    },

    async validaLogin() {
      let loginData = this.datosUsuario;

      try {
        let response = await axios.post("/sistema/main/login/", loginData);

        if (response.data) {
          sessionStorage.setItem("accessToken", JSON.stringify(response.data));

          this.$router.replace("home");
        } else {
          alert("Usuario o clave incorrectos");
        }
      } catch (error) {
        console.log("ENTRA AL CATCH");
        console.log(error);
      }
    },

    // validacion de acceso de Modulo y Submodulo por componente
    async parametroComponente({ state }, config) {
  /* The comment is indicating that the `config` parameter received by the `parametroComponente` action
  should have two properties: `id_modulo` and `id_submodulo`, with their respective values. */
      // config Recibe    {id_modulo":1, "id_submodulo":12 }

      config.id_perfil = sessionStorage.id_perfil;
      config.id_usuario = sessionStorage.id;
      config.webmaster = sessionStorage.webmaster;
      config.token = sessionStorage.token_usuario;
      //console.log('DATA DEL SERVIDOR:', 'CONSULTANDO')
      try {
        let response = await axios.post(
          "/sistema/main/componenteEvento/",
          config
        );
        if (response.data) {
          // console.log('PARAMETRO COMPONENTE DAtA:', response.data)
          state.subModuloEvento = response.data;
        } else {
          //state.subModuloEvento = {};
        }
      } catch (error) {
        //console.log("ENTRO AL CATCH");
        //console.log(error);
        state.subModuloEvento = {};
      }
    },
  },

  getters: {
    componenteEvento: (state) => {
      //console.log('STADO GENERAL', state)
      //console.log('TRAYENDO COMPONENTE EVENTO:', state)
      return state.subModuloEvento;
    },
  },
};
